module.exports = __webpack_public_path__ + "img/overlay-image.fd022562.png";